import { heliosSizes } from '~/constants/common/resizeBreakpoints';
import { useResizeListener } from '~/hooks/common';
import {
  useGeolocation,
  useFetchDeviceDetection,
  useTrackClickEvents
} from '~/hooks/common';
import { useGetFavorites } from '~/hooks/common/favorites';
import useSendViewedEvent from '~/hooks/common/useSendViewedEvent';

export default function ExTaxCreditData() {
  useSendViewedEvent('EV Tax Credit Page Viewed');
  useResizeListener(heliosSizes);
  useFetchDeviceDetection();
  useGeolocation();
  useGetFavorites();
  useTrackClickEvents();

  return null;
}
